import { init, type InstaQLEntity, type User } from "@instantdb/react";
import { signal } from "@preact/signals";
import schema from "../../instant.schema.ts";

const db = init({
  devtool: false,
  appId: "a749930e-6737-4dcf-b039-60c7f5e4e2e6",
  schema,
});

export const {
  useQuery,
  useInfiniteQuery,
  auth,
  queryOnce,
  useAuth,
  tx,
  transact,
} = db;

export type Group = InstaQLEntity<typeof schema, "groups">;

export type ConversationListItem =
  & InstaQLEntity<
    typeof schema,
    "conversations"
  >
  & {
    groups?: { id: string; name: string; lastActivityAt?: number }[];
  };

export type ConversationWithParticipants = ConversationListItem & {
  participants?: string[];
};

export const sessionSig = signal<User | null>(null);
